import type { ReactNode } from 'react'

interface Props {
  children: ReactNode
}

export default function Steps({ children }: Props) {
  return <ol className="steps">{children}</ol>
}
